import React, { useEffect, useState } from 'react';
import ArticleDetailsBody from '../ArticleDetailsBody';
import {
    getCodiceArticolo,
    getDescrizioneArticolo,
    getLocale,
    getMarcaArticolo,
    normalizeEtimClassDetails
} from './utils/utils';
import AppLogo from '../utils/AppLogo';
import { fetchPublicEtimClassDetails } from '../../api';

export const ProductExternal = ({ product, productDetails }) => {
    const [etimClassDetails, setEtimClassDetails] = useState({});
    const language = 'it';

    let productImages = {};
    if (productDetails.metadata.immagine_prodotto) {
        productImages.immagine_prodotto = productDetails.metadata.immagine_prodotto;
    }

    useEffect(() => {
        const fetchEtim = async () => {
            if (productDetails.etim && productDetails.etim.id !== null) {
                const etimClassRes = await fetchPublicEtimClassDetails(productDetails.etim.id)
                setEtimClassDetails(normalizeEtimClassDetails(etimClassRes.data))
            }
        }

        fetchEtim()
    }, [productDetails])

    return (
        <div className="bg-primary login-wrapper">
            <div className="container grid-xl">
                <div className="form-spaced">
                    <div className="text-center" style={{ marginBottom: '16px' }}>
                        <AppLogo />
                    </div>
                    <div className="h5">
                        {getMarcaArticolo(productDetails)}
                        {' - '}
                        {getCodiceArticolo(productDetails)}
                        {' - '}
                        <span style={{ fontWeight: 400 }}>{getDescrizioneArticolo(productDetails)}</span>
                    </div>

                    <ArticleDetailsBody
                        article={productImages}
                        details={productDetails}
                        isPreview={false}
                        initialCategories={[]}
                        language={language}
                        etimClassDetails={etimClassDetails}
                    />
                </div>
            </div>
        </div>
    )
}
